import { ThunkAction } from "redux-thunk";
import { RootState } from "slices";
import { Action, Dispatch } from "redux";
import { registerUser as registerUserApi } from "helpers/backend_helper";
import { registerFailed, registerSuccess, resetRegister } from "./reducer";
import { toast } from "react-toastify";

interface User {
  name: string;
  email: string;
  password: string;
  role: string;
}

export const registerUser =
  (user: User): ThunkAction<void, RootState, unknown, Action<string>> =>
  async (dispatch: Dispatch) => {
    try {
      const response:any = await registerUserApi(user);            

      if (response && response.result.success) {
        toast.success("registered successfully!")
        localStorage.setItem("authToken", response.result.authToken);

        dispatch(registerSuccess(response.result?.user));
      }
    } catch (error: any) {
      console.error("Registration Error:", error);
      dispatch(registerFailed(error));

      if (error.code === "auth/email-already-in-use") {
        toast.error("Email already in use!", { autoClose: 2000 });
      } else if (error.code === "auth/invalid-email") {
        toast.error("The email address is not valid!", { autoClose: 2000 });
      } else if (error.code === "auth/operation-not-allowed") {
        toast.error("Account creation is currently not allowed!", {
          autoClose: 2000,
        });
      } else if (error.code === "auth/weak-password") {
        toast.error("The password is too weak!", { autoClose: 2000 });
      } else {
        console.error("Error:handleUserSignUp", error.message);
      }
    }
  };

export const resetRegisterFlag = () => {
  try {
    const response = resetRegister(false);
    return response;
  } catch (error) {
    return error;
  }
};
